import { apiRequest } from '../apiRequest';

export const updateTelegramDestinationApi = async (id, payload) => {
  return apiRequest('/admin/notification/telegram-destinations/' + id, {
    method: 'PUT',
    body: payload,
    defaultErrorMessage: 'Failed to update Telegram destination',
  });
};
